<template>
    <base-layout>
        <h1 slot="header">
            {{ `app.pages.subscription` | trans }}
        </h1>
        <a slot="buttons" :href="routes.subscription" class="btn btn-primary">
            <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
            {{ `app.back` | trans }}
        </a>
        <v-app id="vuetify-app" class="no--wrap box box-success">
            <v-container>
                <v-layout align-center justify-center column class="box-body">
                    <p>
                        Darmowe konto zostało aktywowane. Pamiętaj, że możesz przejść na wyższy plan, kiedy tylko chcesz..
                    </p>
                    <v-btn
                        :href="routes.subscription"

                        color="primary">
                        {{ 'page.subscriptions.go_back_to_subscription_selection' | trans }}
                    </v-btn>
                </v-layout>
            </v-container>
        </v-app>
    </base-layout>
</template>

<script>
export default {
    props: {
        routes: Object,
    },
}
</script>
